export default "__VITE_ASSET__a8b6c58e__"